export default "__VITE_ASSET__BnD83hCm__"